<template>
    <div class="breadCrumbContainer">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: firstPath }" v-if="isShow(firstPath)">{{
                firstNav
            }}</el-breadcrumb-item>
            <el-breadcrumb-item
                :to="{ path: secondPath }"
                v-if="isShow(secondNav)"
                >{{ secondNav }}</el-breadcrumb-item
            >
            <el-breadcrumb-item v-if="isShow(breadcrumbText)">
                <em class="bold">{{ breadcrumbText }}</em>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    props: {
        //一级导航路由地址
        firstPath: {
            type: String,
            default: "",
        },
        //一级导航名称
        firstNav: {
            type: String,
            default: "",
        },
        //二级导航路由地址
        secondPath: {
            type: String,
            default: "",
        },
        //一级导航名称
        secondNav: {
            type: String,
            default: "",
        },
        //面包屑文字
        breadcrumbText: {
            type: String,
            default: "",
        },
    },
    computed:{
        isShow(){
            return function(content){
                let show = content.length > 0 ? true : false;
                return show
            }
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="less" scoped>
.bold{
    font-weight: bold;
    font-style: normal;
}
.breadCrumbContainer {
    display: flex;
    align-items: center;
    height: 56px;
}
</style>
